import React from 'react';
import styled from 'styled-components';
import { Letter } from '../hooks/useWordle';

interface Props {
  nbLetters: number;
  guess?: Letter[];
  currentGuess?: string;
}

const Row: React.FC<Props> = ({ nbLetters, guess, currentGuess }) => {
  if (guess) {
    return (
      <Container className='row past'>
        {guess.map((l, i) => (
          <div key={i} className={l.color}>
            {l.key}
          </div>
        ))}
      </Container>
    );
  }

  if (currentGuess) {
    let letters = currentGuess.split('');

    return (
      <Container className='row current'>
        {letters.map((letter: string, i: number) => (
          <div key={i} className='filled'>
            {letter}
          </div>
        ))}
        {[...Array(nbLetters - letters.length)].map((i) => (
          <div key={i}></div>
        ))}
      </Container>
    );
  }

  return (
    <Container className='row'>
      {Array.from({ length: nbLetters }).map((_, i) => (
        <div key={i} className='base'></div>
      ))}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  text-align: center;
  justify-content: center;
  font-family: "Poppins", sans-serif;

  > div {
    display: block;
    width: 60px;
    height: 60px;
    border: 2px solid #d8cba9;
    border-radius: 14px;
    background-color: #fffaef;
    margin: 4px;
    text-align: center;
    line-height: 60px;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 2.25rem;
    color: #0b3d55;
  }

  .green {
    --background-color: #1b3a8a;
    --border: 2px solid transparent;
    --color: #fffaef;
    animation: flip 0.5s ease forwards;
  }

  .yellow {
    --background-color: rgba(27, 58, 138, 0.6);
    --border: 2px solid transparent;
    --color: #fffaef;
    animation: flip 0.5s ease forwards;
  }

  .grey {
    --background-color: #6b7876;
    --border: 2px solid transparent;
    --color: #fffaef;
    animation: flip 0.5s ease forwards;
  }

  // Delay
  > div:nth-child(2) {
    animation-delay: 0.1s;
  }
  > div:nth-child(3) {
    animation-delay: 0.2s;
  }
  > div:nth-child(4) {
    animation-delay: 0.3s;
  }
  > div:nth-child(5) {
    animation-delay: 0.4s;
  }
  > div:nth-child(6) {
    animation-delay: 0.5s;
  }
  > div:nth-child(7) {
    animation-delay: 0.6s;
  }
  > div:nth-child(8) {
    animation-delay: 0.7s;
  }
  > div:nth-child(9) {
    animation-delay: 0.8s;
  }
  > div:nth-child(10) {
    animation-delay: 0.9s;
  }

  // Animation

  @keyframes flip {
    0% {
      transform: rotateX(0);
      background-color: #fffaef;
      border-color: #d8cba9;
    }
    45% {
      transform: rotateX(90deg);
      background-color: #fffaef;
      border-color: #d8cba9;
    }
    55% {
      transform: rotateX(90deg);
      background: var(--background-color);
      border: var(--border);
      color: var(--color);
    }
    100% {
      transform: rotateX(0deg);
      background-color: var(--background-color);
      border: var(--border);
      color: var(--color);
    }
  }

  .filled {
    animation: bounce 0.08s ease-in-out forwards;
  }

  // A VOIR SI ON GARDE
  // bounce animation when letter is typed
  @keyframes bounce {
    0% {
      transform: scale(1);
      border-color: #2a9d8f;
    }
    50% {
      transform: scale(1.2);
    }
    100% {
      transform: scale(1);
      border-color: #2a9d8f;
    }
  }
`;

export default Row;
